
(function() {
  'use strict';

  const diffChars = (value1, value2) => {
    const charsDiff = Diff.diffChars(value1, value2);

    const ret = charsDiff.map((chars) => {
      if (!chars.removed && chars.value.replace('\n').length) {
        return `<span class="${chars.added ? 'changed': ''}">${chars.value.replace(/\n$/, '')}</span>`;
      }

      return null;
    }).filter(Boolean)
      .join('');

    return ret;
  };

  const diff = (o1, o2, highlightDifferences) => {
    const keys = _.uniq(_.assign(Object.keys(o1), Object.keys(o2)));

    const lines1 = (Object.keys(o1).length ? keys : [])
      .map((key) => `<strong>${key}</strong>: ${o1[key] ? o1[key] : ''}`)
      .join('\n');
    const lines2 = (Object.keys(o2).length ? keys : [])
      .map((key) => `<strong>${key}</strong>: ${o2[key] ? o2[key] : ''}`)
      .join('\n');

    const diffLines = Diff.diffTrimmedLines(lines2, lines1);

    let pred = null;
    const items = diffLines.reduce((result, item) => {
      let className = '';
      if (item.added && highlightDifferences) {
        className = 'changed';
      }

      if (item.removed) {
        pred = item;
        return result;
      }

      if (pred && item.value) {
        item.value = `${diffChars(item.value, pred.value)}`;
        pred = null;
      }

      const splited = item.value.split('\n')
        .map((line) => line.replace('\n', ''))
        .filter(Boolean);

      return result.concat(splited.map((value) => `<li class="${className}">${value}</li>`));
    }, []);

    return `<ol class="diff-list">${items.join('')}</ol>`;
  };

  const diffWithHighlight = (o1, o2) => diff(o1, o2, true);

  const processDiffs = ({ scope }) => {
    const { historicos } = scope;
    const index = scope.index;
    scope.historicosToCompare = [
      historicos[index - 1],
      historicos[index]
    ].filter(Boolean);

    scope.historicosToCompare.forEach((item) => delete item.payload.id);
    scope.historicosToCompare[0].diff = diff(scope.historicosToCompare[0].payload, {});
    if (scope.historicosToCompare[1]) {
      scope.historicosToCompare[1].diff = diffWithHighlight(
        scope.historicosToCompare[0].payload,
        scope.historicosToCompare[1].payload
      );
    }
  };

  const processDate = ({ scope }) => {
    const { historicos } = scope;
    historicos.forEach(function(historico) {
      historico.created_at = Date.parse(historico.created_at);
    });
  };

  const openModal = ({ historicos, scope, modal }) => {
    scope.historicos = historicos;
    scope.index = scope.historicos.length - 1;
    processDiffs({ scope });
    processDate({ scope });

    scope.modalInstance = modal.open({
      templateUrl: 'modal-historico-alteracoes.html',
      scope,
      size: 'lg'
    });
  };

  // eslint-disable-next-line max-lines-per-function,max-params
  const HistoricoAlteracoes = ($uibModal, MessagesService, HistoricoAlteracoeService, LoadingService, $timeout) => (
    {
      templateUrl: 'views/directives/historico_alteracoes_template.html',
      restrict: 'AE',
      scope: {
        id: '@',
        type: '@',
        title: '@'
      },
      // eslint-disable-next-line max-lines-per-function,max-params
      link: (scope) => {
        scope.next = () => {
          if (!scope.hide && scope.index < scope.historicos.length) {
            scope.hide = true;
            $timeout(() => {
              scope.index++;
              scope.hide = false;
              processDiffs({ scope });
              scope.changingPage = false;
            }, 290);
          }
        };

        scope.close = () => {
          scope.modalInstance.close();
        };

        scope.prior = () => {
          if (!scope.hide && scope.index > 0) {
            scope.hide = true;
            $timeout(() => {
              scope.index--;
              scope.hide = false;
              processDiffs({ scope });
            }, 290);
          }
        };

        scope.showHistoricoAlteracoes = () => {
          LoadingService.showLoading();
          HistoricoAlteracoeService.list({
            id: scope.id,
            type: scope.type
          }).then((result) => {
            LoadingService.hideLoading();
            const { data } = result;
            if (!data.length) {
              MessagesService.alert('Nenhum registro encontrado');
              return;
            }
            openModal({
              historicos: data,
              scope,
              modal: $uibModal
            });
          })
            .catch((error) => {
              LoadingService.hideLoading();
              console.error('Falha ao listar histórico de alterações', error);
              MessagesService.alert('Falha ao listar histórico');
            });
        };

        scope.title = scope.title || 'Histórico de Alterações';
      }
    }
  );

  HistoricoAlteracoes.$inject = [
    '$uibModal',
    'MessagesService',
    'HistoricoAlteracoeService',
    'LoadingService',
    '$timeout'
  ];

  angular
    .module('webAgro1App')
    .directive('historicoAlteracoes', HistoricoAlteracoes);
}());
